import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router';
import styles from './WaterSliderMini.css';
import { SetWaterLevel } from '../../actions';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import withStyles from '../../decorators/withStyles';


class WaterSliderMini extends Component {

  static propTypes = {
    header: PropTypes.bool,
  };

  static defaultProps = {
    header: false,
  };

  constructor(props) {
    super(props);
    this.tickMap = {
      "m": [10, 5, 3, 2.5, 2, 1.5, 1, 0.5].reverse(),
      "ft": [10, 9, 8, 7, 6, 5, 4, 3, 2, 1].reverse()
    };
  }

  handleChange = e => {
    this.props.dispatch(SetWaterLevel({
      level: this.tickMap[this.props.waterLevel.unit][+e.target.value - 1],
      unit: this.props.waterLevel.unit
    }));
  };

  render() {
    const maxLevel = this.tickMap[this.props.waterLevel.unit].length;
    var classes = this.props.header ? " header" : "";
    return (
      <div className={"MiniSlider" + classes}>
        <label htmlFor="mini-slider">Water level: {this.props.waterLevel.level} {this.props.waterLevel.unit}&nbsp;
          <Link to={{pathname: "/about", hash: "#about-water-level", state: {modal: true, modalTitle: "About this site",
                                                                        returnTo: location.pathname}}}>
            <span className="icon question-mark" />
          </Link>
        </label>
        <input name="mini-slider" type="range" min="1" max={maxLevel}
               className={`level-${this.props.waterLevel.level}`}
               value={`${this.tickMap[this.props.waterLevel.unit].indexOf(this.props.waterLevel.level) + 1}`}
               onChange={this.handleChange}/>
      </div>);
  };
}

export default compose(
  withStyles(styles),
  connect((state) => {return {waterLevel: state.waterLevel};}),
)(WaterSliderMini);
